import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar, ErrorMessage,
  ModalFormContainer,
  RadioButtonGroup
} from '..';
import { IdentityContext } from '../../context';
import { useUpdate } from '../../hooks';


const raceOptions = [
  { id: 'asian', label: 'Asian' },
  { id: 'black', label: 'Black' },
  { id: 'hispanic', label: 'Hispanic' },
  { id: 'white', label: 'White' }
];

interface RaceProps {
  customHandleSave?: () => void;
}

export function Race({ customHandleSave }: RaceProps) {
  const navigate = useNavigate();
  const { person } = useContext(IdentityContext);

  const { handleUpdate } = useUpdate('people');

  const handleBack = useCallback((event) => {
    event.preventDefault();
    () => navigate('#birth-info');
  }, [ navigate ]);

  const handleSave = useCallback(async (event) => {
    event.preventDefault();
    console.log('handleSave Race');
    const elements = document.getElementsByName('race');

    const payload = {} as Record<string, string>;

    Array.from(elements).forEach((element) => {
      if ((element as HTMLInputElement).checked) {
        payload.race = element.id;
      }
    });

    await handleUpdate(person.id, payload);

    if (customHandleSave) {
      console.log('customHandleSave Race');
      return customHandleSave();
    }

    navigate('/profile');
  }, [ handleUpdate, person.id, customHandleSave ]);

  // turn to controlled value to save
  return (
    <ModalFormContainer
      icon="diversity_3"
      header="What is your race?"
      step={4}
      steps={4}
    >
      <RadioButtonGroup options={raceOptions} name="race" />
      <ErrorMessage message="" />
      <ButtonBar
        handlePrimary={handleSave}
        primaryText="Save"
        handleSecondary={handleBack}
        secondaryText="Back"
      />
    </ModalFormContainer>
  );
}
